import React from 'react';
import { Button } from '../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { setDeps, setNewOrderField } from '../../redux/orderSlice';
import { accessor } from '../../helpers';
import { Search } from '../../components/Search';
import { OrdersFilters } from './OrdersFilters';

export const OrdersManager = ({ titles, searchSets, setSearchSets }) => {
    const dispatch = useDispatch();

    const user = useSelector((state) => state.auth);
    const canCreateOrder = accessor.createOrder(user);

    const clickCreateButtonHandler = () => {
        const ordersPanel = document.getElementById('orders');
        ordersPanel?.scrollTo(0, 0);
        dispatch(setNewOrderField(true));
    };

    const depsIds = useSelector((state) => state.orders.deps);
    const resetDepsFilterHandler = () => {
        dispatch(setDeps([]));
    };

    return (
        <div className="orders-manager">
            <div className="container">
                <div className="orders-manager__header">
                    <div className="orders-manager__column">
                        <div id='average-cheque-root'></div>
                        <div id='orders-count-root'></div>
                    </div>
                    <div className="orders-manager__column">
                        <Search sets={searchSets} titles={titles} setSets={setSearchSets} />
                    </div>
                    <div className="orders-manager__column">
                        <div id='moderns-count-root'></div>
                        <div id='cancel-count-root'></div>
                        <div id="orders-total-sum"></div>
                        <div id="orders-clear-sum"></div>
                    </div>
                    <div className="orders-manager__column">
                        {!!depsIds.length && <Button text='← к заявкам' onClick={resetDepsFilterHandler}/>}
   
                            <div className="create-order-button">
                                <Button
                                    size="normal"
                                    disabled={!canCreateOrder}
                                    onClick={clickCreateButtonHandler}
                                    text="создать заявку"
                                />
                            </div>
                    </div>
                </div>
                <OrdersFilters titles={titles} />
            </div>
        </div>
    );
};
